module.exports = __webpack_public_path__ + "img/p1_bg.b58590ed.jpg";